import styles from 'components/styles/main-menu.css'

const MenuItem = ({ isMainMenuOpen, item, onClick }) => {
  return (
    <div className={styles.mainMenuItem} onClick={onClick}>
      <img src={item.icon} className={styles.mainMenuIcon} />
      {isMainMenuOpen ? <span className={styles['menu-text']}>{item.name}</span> : ''}
    </div>
  )
}

export default MenuItem
